import { motion } from "framer-motion";
import { Clock, ShieldCheck } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const EASE = [0.16, 1, 0.3, 1];

const EXAMS = [
  "Hemograma completo",
  "Glucosa",
  "Perfil lipídico",
  "Perfil tiroideo",
  "Perfil hormonal",
  "Uroanálisis",
  "Microbiología",
  "Pruebas especializadas",
];

const LabFeature = () => (
  <section
    id="laboratorio"
    data-testid="lab-section"
    className="noise-overlay relative overflow-hidden bg-black py-24 text-white sm:py-32"
  >
    <div className="pointer-events-none absolute -left-32 top-0 h-[420px] w-[420px] rounded-full bg-red-600/15 blur-[120px]" />
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-2">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: EASE }}
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-red-400">
          03 — Laboratorio clínico
        </p>
        <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight sm:text-4xl">
          Análisis clínicos
        </h2>
        <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-400">
          Nuestro laboratorio procesa tus muestras con tecnología automatizada
          y estrictos controles de calidad, para que tengas tus resultados
          rápido y sin complicaciones.
        </p>

        <div className="mt-8 flex flex-wrap gap-2.5">
          {EXAMS.map((exam, i) => (
            <motion.span
              key={exam}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05, ease: EASE }}
              data-testid={`lab-exam-chip-${i}`}
              className="rounded-full border border-slate-700 bg-slate-800/60 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.12em] text-slate-300 transition-colors duration-300 hover:border-red-500 hover:text-red-300"
            >
              {exam}
            </motion.span>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-6">
          <div className="flex items-center gap-3">
            <Clock size={18} className="text-red-400" />
            <span className="text-sm text-slate-300">
              Entrega rápida de resultados
            </span>
          </div>
          <div className="flex items-center gap-3">
            <ShieldCheck size={18} className="text-red-400" />
            <span className="text-sm text-slate-300">
              Control de calidad certificado
            </span>
          </div>
        </div>

        <button
          data-testid="lab-agendar-cta"
          onClick={() => {
            window.dispatchEvent(
              new CustomEvent("select-service", {
                detail: "Exámenes de Laboratorio Clínico",
              })
            );
            scrollToId("contacto");
          }}
          className="mt-10 rounded-full bg-red-600 px-7 py-3.5 text-sm font-medium text-white transition-[background-color,transform] duration-300 hover:bg-red-500 hover:scale-[1.03] active:scale-95"
        >
          Reservar mi análisis
        </button>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative"
      >
        <div className="overflow-hidden rounded-[2rem] border border-slate-700/60 shadow-2xl">
          <img
            data-testid="lab-image"
            src="https://images.unsplash.com/photo-1614308460927-5024ba2e1dcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxtZWRpY2FsJTIwbGFib3JhdG9yeSUyMGJsb29kJTIwdGVzdCUyMHNjaWVudGlzdCUyMG1pY3Jvc2NvcGV8ZW58MHx8fHwxNzg5MDkzMTc4fDA&ixlib=rb-4.1.0&q=85"
            alt="Análisis de laboratorio clínico"
            className="aspect-[4/3] w-full object-cover"
          />
        </div>
        <div
          data-testid="lab-badge"
          className="absolute -bottom-6 left-6 rounded-2xl border border-slate-700 bg-slate-800/90 px-6 py-4 shadow-xl backdrop-blur"
        >
          <p className="font-display text-3xl font-semibold text-red-400">
            24h
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
            o menos en tus resultados
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default LabFeature;
